<template>
    <div>
        <Chart :cdata="cdata" />
    </div>
</template>

<script>
import Chart from './chart.vue';
import { transportTodayByCity } from '../../api/holdMy'
export default {
    data() {
        return {
            cdata: [
                { name: '厦门', value: '0000' },
                { name: '长沙', value: '0000' },
                { name: '广州', value: '0000' },
                { name: '宁波', value: '0000' },
                { name: '上海', value: '0000' },
                { name: '温州', value: '0000' },
                { name: '临沂', value: '0000' },
                { name: '成都', value: '0000' },
                { name: '北京', value: '0000' },
                { name: '苏州', value: '0000' },
                { name: '泉州', value: '0000' },
                { name: '郑州', value: '0000' },
                { name: '佛山', value: '0000' },
                { name: '莆田', value: '0000' },
                { name: '济南', value: '0000' },
                { name: '漳州', value: '0000' },
                { name: '福州', value: '0000' },
                { name: '杭州', value: '0000' },
                { name: '深圳', value: '0000' },
                { name: '武汉', value: '0000' },
                { name: '徐州', value: '0000' },
                { name: '南昌', value: '0000' },
                { name: '合肥', value: '0000' },
                { name: '宁德', value: '0000' },
                { name: '贵阳', value: '0000' },
                { name: '绍兴', value: '0000' },
                { name: '青岛', value: '0000' },
                { name: '台州', value: '0000' }
            ],
        }
    },
    components: {
        Chart,
    },
    created() {
        this.drawTimingFn();
    },
    methods: {
        // 20 分钟一次
        drawTimingFn() {
            this.getTransportTodayByCity();
            this.drawTiming = setInterval(() => {
                this.getTransportTodayByCity();
            }, 20 * 60000);
        },


        // 获取城市信息
        getTransportTodayByCity() {
            let data = {
                autoIncId: 1,// id
            }
            transportTodayByCity(data).then(res => {
                if (res.result == 0) {
                    this.cdata = res.userdata;
                    this.$store.state.cityTempData = this.cdata;
                }
            }).catch(error => {
                console.log(error);
            })
        },
    }
}
</script>

<style lang="scss" scoped></style>